import { PRIORITY } from "@/lib/format";

export function PriorityBadge({ priority, size = "sm" }) {
  const lvl = priority?.level;
  const p = PRIORITY[lvl];
  if (!p) return <span className="text-xs text-zinc-600">—</span>;
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={`priority-${lvl}`}
      className={`inline-flex items-center gap-1.5 uppercase tracking-wider font-medium rounded-sm border ${cls}`}
      style={{ color: p.color, borderColor: `${p.color}4d`, backgroundColor: `${p.color}14` }}
      title={priority?.giorni_asta != null ? `Asta tra ${priority.giorni_asta} giorni` : p.label}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: p.color }} />
      {p.short}
    </span>
  );
}
